import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id1 = uuid();
    const id2 = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id1})`}>
                <g clipPath={`url(#${id2})`}>
                    <rect width='24' height='24' rx='4' fill='#BB7800' />
                    <rect x='3.99976' y='5.33337' width='16' height='14' fill='white' />
                    <path
                        d='M24.469 0.131453C24.6861 0.348578 24.8092 0.641699 24.8092 0.949295V23.2663C24.8092 23.9068 24.2917 24.4243 23.6512 24.4243H0.491016C-0.149507 24.4243 -0.666992 23.9068 -0.666992 23.2663V-6.84193C-0.666992 -7.48245 -0.149507 -7.99994 0.491016 -7.99994H15.86C16.1676 -7.99994 16.4643 -7.8769 16.6814 -7.65977L24.469 0.131453ZM22.1385 1.48126L15.328 -5.32928V1.48126H22.1385ZM10.498 17.1867V13.8741H12.6429C14.8348 13.8741 16.2689 12.4393 16.2689 10.3234C16.2689 8.21652 14.8366 6.76467 12.6508 6.76467H8.88658C8.7714 6.76467 8.66095 6.81042 8.57951 6.89186C8.49807 6.9733 8.45232 7.08375 8.45232 7.19892V17.1867C8.45232 17.3019 8.49807 17.4124 8.57951 17.4938C8.66095 17.5752 8.7714 17.621 8.88658 17.621H10.0638C10.1789 17.621 10.2894 17.5752 10.3708 17.4938C10.4523 17.4124 10.498 17.3019 10.498 17.1867ZM10.498 12.1447H11.761C13.4915 12.1447 14.1924 11.6768 14.1924 10.3234C14.1924 9.16356 13.5367 8.50964 12.3877 8.50964H10.498V12.1447Z'
                        fill='#BB7800'
                    />
                </g>
            </g>
            <defs>
                <clipPath id={id1}>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
                <clipPath id={id2}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
